import {Controller} from '@hotwired/stimulus';

/**
 * Désactive les champs d'un bloc tant qu'il porte `hidden`, pour qu'ils ne soient ni postés ni validés,
 * et les réactive quand il s'affiche. Se pose sur le bloc que masque un autre contrôleur :
 *
 *   {{ form_row(form.category, {row_attr: stimulus_controller('disable-when-hidden').toArray()
 *       |merge(stimulus_target('field-visibility', 'dependent').toArray())
 *       |merge({'data-field-visibility-hide-on': '1', hidden: form.all.vars.checked})}) }}
 *
 * Chaque champ du bloc suit son état, y compris un champ rendu `disabled` : ne pas le poser sur un bloc
 * qui en contient un.
 */
export default class extends Controller {
  connect() {
    this.sync();
    this.observer = new MutationObserver(() => this.sync());
    this.observer.observe(this.element, {attributes: true, attributeFilter: ['hidden']});
  }

  disconnect() {
    this.observer.disconnect();
  }

  sync() {
    for (const field of this.element.querySelectorAll('input, select, textarea')) {
      field.disabled = this.element.hidden;
    }
  }
}
